export const riskPatientDetailsMessage ={
    titleAndSubtitle:{
        title:'Risk Member Details',
        subTitleStartString:'Showing Patient Details in ',
        subTitleMiddleString:' bracket based on ',
        subTitleEndString:' Risk Stratification Metric',
    },
    breadCrumb:{
        text:'text',
        summary:'Summary',
        riskPatientdetails:'Risk Member Details',
    },
    dates:{
        startDate:'2021-01-10',
        endDate:'2022-01-10',
    },
};

export const medicalHistoryClaimIDMessage = {
    emptyData:
      'The chosen group does not have any recommended actions to take at present',
    downloadCSV: 'Download CSV',
    downloadExcel: 'Download Excel',
    downloadCSVMessage: 'CSV File will get downloaded.',
    downloadExcelMessage: 'Excel File will get downloaded.',
    LEFT_VALUE: 'Chart View',
    RIGHT_VALUE: 'Download View',
  };